import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import { composePS } from '@cd/pipe';
import Icon from '@mui/material/Icon';
import ListSubheader from '@mui/material/ListSubheader';
import eLocalLogoSVG from '../../images/eLocalLogo.svg';
import SVG from 'react-inlinesvg';
import styles2 from '../css/Drawer.module.scss';
import { either, noop } from '../../lib/utils/utils';
import { postJSONPS } from '../../lib/utils/fetch';
import cn from 'classnames';
import BurnLines from './BurnLines';

/** postOrgName ::  Promise(Either) */
const postOrgName = () =>
	composePS(postJSONPS)('POST', `/orgInfo`, {
		body: JSON.stringify({})
	});

const drawerWidth = 320;

const ClickableItem = ({
	title,
	href,
	onChangeURL,
	iconName,
	flash,
	flashIconName
}) => {
	const [run, setRun] = useState(true);
	useEffect(() => {
		setTimeout(() => {
			setRun(false);
		}, 8000);
	}, []);
	const handleClick = () => {
		onChangeURL(href);
	};
	return (
		<ListItem button key={title} onClick={handleClick}>
			<ListItemIcon>
				<Icon className={cn({ [styles2.flash]: flash })}>
					{run && flash ? flashIconName : iconName}
				</Icon>
			</ListItemIcon>
			<ListItemText primary={title} />
		</ListItem>
	);
};

const eResponsiveDrawer = ({
	navList = [],
	onChangeURL,
	mobileOpen,
	handleDrawerToggle = noop
}) => {
	const theme = useTheme();
	const [orgInfo, setOrgInfo] = useState({});

	useEffect(() => {
		postOrgName().then(
			either(
				console.log,
				({ orgInfo: { orgName, address1, address2, phone } }) => {
					setOrgInfo({ orgName, address1, address2, phone });
				}
			)
		);
	}, []);

	const { orgName, address1, address2, phone } = orgInfo;
	const drawer = (
			<div className={styles2.drawerInner}>
				<div style={theme.mixins.toolbar}>
					<div className={styles2.logoWrap}>
						<div className={styles2.svgWrap}>
							<SVG
								viewBox="0 0 520 520"
								className={styles2.svg}
								src={eLocalLogoSVG}
							/>
							<BurnLines />
						</div>

						<div className={styles2.burnLine} />
						<div className={styles2.toolbarText}>
							<span>{orgName}</span>
							<span>{address1}</span>
							<span>{address2}</span>
							<span>{phone}</span>
						</div>
					</div>
				</div>
				<Divider />
				<List className={styles2.navList}>
					{navList.map(
						({
							title,
							isDivider,
							isHeader,
							iconName,
							href,
							flash,
							flashIconName
						}) =>
							isDivider ? (
								<Divider key={href} />
							) : isHeader ? (
								<ListSubheader key={href} component="div">
									{title}
								</ListSubheader>
							) : (
								<ClickableItem
									flash={flash}
									flashIconName={flashIconName}
									key={href}
									href={href}
									title={title}
									onChangeURL={onChangeURL}
									iconName={iconName}
								/>
							)
					)}
				</List>
				<div className={styles2.footer}>CyberDev © 2026 v.1.6.71</div>
			</div>
		);

		return (
			<Box
				component="nav"
				sx={(theme) => ({
					[theme.breakpoints.up('md')]: {
						width: drawerWidth,
						flexShrink: 0
					}
				})}>
				{/* The implementation can be swapped with js to avoid SEO duplication of links. */}

				<Drawer
					variant="temporary"
					anchor={theme.direction === 'rtl' ? 'right' : 'left'}
					open={mobileOpen}
					onClose={handleDrawerToggle}
					sx={{ display: { xs: 'block', md: 'none' } }}
					PaperProps={{ sx: { width: drawerWidth } }}>
					{drawer}
				</Drawer>
				<Drawer
					sx={{ display: { xs: 'none', md: 'block' } }}
					PaperProps={{ sx: { width: drawerWidth } }}
					variant="permanent"
					open>
					{drawer}
				</Drawer>
			</Box>
		);
};

export default eResponsiveDrawer;
